import types from "../types";

const initialState = {
  loading: false,
  mentorHourLogs: [],
  error: null,
};

const mentorHourLogsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case types.GETALL_MENTORHOURLOG:
    case types.CREATE_HOURLOG:
    case types.UPDATE_HOURLOG:
    case types.DELETE_HOURLOG:
    case types.APPROVE_HOURLOG:
    case types.SAVE_HOURLOG:
      return {
        ...state,
        loading: true,
      };
    case types.GETALL_MENTORHOURLOG_SUCCESS:
      return {
        ...state,
        loading: false,
        mentorHourLogs: action.payload,
        error: null,
      };
    case types.CREATE_HOURLOG_SUCCESS:
    case types.UPDATE_HOURLOG_SUCCESS:
    case types.DELETE_HOURLOG_SUCCESS:
    case types.APPROVE_HOURLOG_SUCCESS:
    case types.SAVE_HOURLOG_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.HOURLOG_REQUEST_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return {
        ...state,
      };
  }
};

export default mentorHourLogsReducer;
